// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chart-median"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 21H3V3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19 6.49953C19 4.79008 17.6569 3.4043 16 3.4043C14.3431 3.4043 13 4.79008 13 6.49953V8.49953M7 14.5714C7 16.465 8.34315 18 10 18C11.6569 18 13 16.465 13 14.5714V12.5M16 10.502H15.9961V10.498H16V10.502ZM19.0039 10.502H19V10.498H19.0039V10.502ZM10 10.502H9.99609V10.498H10V10.502ZM7.00391 10.5H7V10.4961H7.00391V10.5ZM13.0039 10.502H13V10.498H13.0039V10.502Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chart-median')
export default class ChartMedianIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-median',
    }
  }
}
